import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDateInput,
  MimaDropZone,
  MimaInput,
  MimaText,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const UpdateInstantPayment = ({
  loading,
  onSubmit,
  closeModal,
  validationSchema,
  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb={4} width="38rem">
        Update Instant Payment
      </MimaText>
      <MimaText labelTitle="Buyer" mb={2}>
        {`${singleItem.buyer.firstname} ${singleItem.buyer.lastname} - ${singleItem.buyer.username}`}
      </MimaText>
      <MimaText mb={2} labelTitle="Confirm Buyer was Paid">
        {amountFormatter(singleItem.buyerCreditValue.currencyCode).format(
          singleItem?.buyerCreditValue.amount
        )}
      </MimaText>
      <Formik
        initialValues={{
          amount: 0,
          adminBuyerPaymentDateTime: "",
          adminBuyerPaymentProofUrls: [],
          files: [],
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaInput
              name="amount"
              labelTitle="Amount"
              type="number"
              placeholder="Enter amount"
              value={values.amount}
              onChange={handleChange("amount")}
              onBlur={handleBlur("amount")}
              error={errors.amount}
              touched={touched.amount}
            />
            <MimaDateInput
              labelTitle="Admin Payment Date/Time"
              name="adminBuyerPaymentDateTime"
              value={values.adminBuyerPaymentDateTime}
              onChange={(text) => {
                setFieldValue("adminBuyerPaymentDateTime", text);
              }}
              onBlur={handleBlur}
              touched={touched.adminBuyerPaymentDateTime}
              error={errors.adminBuyerPaymentDateTime}
              mt={2}
              width={38}
              showTimeSelect
            />

            <MimaDropZone
              title="Upload file"
              info="Maximum file size 1MB"
              maxNumOfImages={3}
              files={values.files}
              setFiles={(newFiles) => {
                setFieldValue("files", newFiles);
              }}
              labelTitle="Upload Admin Payment Proof Urls"
              name="adminBuyerPaymentProofUrls"
            />
            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default UpdateInstantPayment;
